import { Typography } from 'antd';

const { Text } = Typography;

interface LogoProps {
  height?: number;
  collapsed?: boolean;
  darkMode?: boolean;
}

export default function Logo({ height = 32, collapsed = false, darkMode = false }: LogoProps) {
  const fontSize = height * 0.8;
  
  if (collapsed) {
    return (
      <div style={{ display: 'inline-flex', alignItems: 'center' }}>
        <Text
          style={{
            fontSize: fontSize * 1.2,
            fontWeight: 700,
            color: '#ffffff',
            letterSpacing: '-0.5px',
            fontFamily: '"Inter", sans-serif',
            lineHeight: 1,
          }}
        >
          R<span style={{ color: '#FF5d00', fontSize: fontSize * 0.8 }}>_</span>
        </Text>
      </div>
    );
  }
  
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
      <Text
        style={{
          fontSize,
          fontWeight: 700,
          color: darkMode ? '#001350' : '#ffffff',
          letterSpacing: '-0.5px',
          fontFamily: '"Inter", sans-serif',
        }}
      >
        RE
        <span style={{ color: '#FF5d00' }}>-</span>
        PACKED
      </Text>
    </div>
  );
}
